module.exports = __webpack_public_path__ + "images/back892c98a01d29823e368b138002565c5c.svg";